import { MisconfigurationsAppBaseDataProvider } from './MisconfigurationsAppBaseDataProvider';
import { MisconfigurationsAppWebComponentSchema } from '../types';

export class MisconfigurationsAppNirvanaDataProvider extends MisconfigurationsAppBaseDataProvider {
  async getDataForView(): Promise<MisconfigurationsAppWebComponentSchema> {
    return {} as unknown as MisconfigurationsAppWebComponentSchema;
  }
}
